/**
 * CUSTOM_HEADER.JS - Authentic Lympha Flow Header & Cart Drawer Management
 */
(function() {
  'use strict';

  function triggerCartDrawer(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    
    if (typeof window.openCart === 'function') {
      window.openCart();
      return;
    }

    const drawer = document.getElementById('cart-drawer');
    const overlay = document.querySelector('.custom_overlay2');
    if (drawer) {
      drawer.classList.add('open');
      drawer.classList.remove('is-closed');
      drawer.style.display = 'block';
    }
    if (overlay) overlay.classList.add('active');
    document.body.classList.add('overflow-hidden');
  }

  function attachListeners() {
    const cartToggles = document.querySelectorAll('#cart-toggle, .header_cart_toggle, .header_cart, a[href="/cart"], .cart_count_js');
    cartToggles.forEach(function(btn) {
      btn.style.cursor = 'pointer';
      btn.addEventListener('click', triggerCartDrawer, true);
    });

    const menuToggle = document.getElementById('drawer-toggle');
    if (menuToggle) {
      menuToggle.addEventListener('click', function(e) {
        e.preventDefault();
        const menu = document.querySelector('.drawer-menu, .mobile-menu-drawer');
        if (menu) menu.classList.toggle('active');
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachListeners);
  } else {
    attachListeners();
  }

  window.openCartDrawer = triggerCartDrawer;
})();
